export const styles = {
  mainContainer:
    "flex gap-2 overflow-x-auto flex-nowrap max-h-16 whitespace-nowrap w-full py-1 items-end",
  all: "px-4 py-1 text-white bg-purple-500 rounded-full shadow-md sm:px-6 hover:bg-purple-600 h-8",
  admin:
    "px-4 py-1 text-white bg-blue-500 rounded-full shadow-md sm:px-6 hover:bg-blue-600 h-8",
  nonAdmin:
    "px-4 py-1 text-white bg-green-400 rounded-full shadow-md sm:px-6 hover:bg-green-500 h-8",
};
